import { getAppVersion, getSystemType, isDianpingAppOrWebview, isMiniProgramOrWebview, SystemType } from '@nibfe/mkt-env-api';
export const getSystemVersion = () => {
    try {
        const version_name = getAppVersion();
        if (version_name === '0') {
            return '';
        }
        return version_name;
    }
    catch (error) {
        return '';
    }
};
export function getUTMMedium() {
    try {
        const systemType = getSystemType();
        // 优先判断是否为鸿蒙环境
        if (systemType === SystemType.harmony) {
            return 'harmonyOS';
        }
        let utm_medium = systemType === SystemType.android ? 'android' : 'iphone';
        if (isMiniProgramOrWebview()) {
            return 'WEIXINPROGRAM';
        }
        return utm_medium;
    }
    catch (e) {
        return '';
    }
}
export const getUTMParams = (ctx) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    return {
        utm_source: ((_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams) === null || _b === void 0 ? void 0 : _b.utm_source) || (isDianpingAppOrWebview() ? 'null' : 'meituaninternaltest'),
        utm_medium: ((_d = (_c = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _c === void 0 ? void 0 : _c.queryParams) === null || _d === void 0 ? void 0 : _d.utm_medium) || getUTMMedium() || 'android',
        utm_campaign: ((_f = (_e = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _e === void 0 ? void 0 : _e.queryParams) === null || _f === void 0 ? void 0 : _f.utm_campaign) || (isDianpingAppOrWebview() ? 'Adianping-novaBdianping-novaD0H0' : 'AgroupBgroupC0D200E0'),
        utm_content: ((_h = (_g = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _g === void 0 ? void 0 : _g.queryParams) === null || _h === void 0 ? void 0 : _h.utm_content) || ((_k = (_j = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _j === void 0 ? void 0 : _j.commonParams) === null || _k === void 0 ? void 0 : _k.uuid) || '',
        utm_term: ((_m = (_l = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _l === void 0 ? void 0 : _l.queryParams) === null || _m === void 0 ? void 0 : _m.utm_term) || '1200420200',
        version_name: ((_p = (_o = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _o === void 0 ? void 0 : _o.queryParams) === null || _p === void 0 ? void 0 : _p.version_name) || getSystemVersion() || '12.42.200'
    };
};
